import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  FormGroup,
  FormBuilder,
  FormArray,
  Validators,
  FormControl,
  AbstractControl,
  ValidatorFn,
} from '@angular/forms';
import * as validatorUtility from '@cigna/cigna-for-brokers/shared/util';

@Component({
  selector: 'cigna-cfb-csb-contractor-box',
  templateUrl: './csb-contractor-box.component.html',
  styleUrls: ['./csb-contractor-box.component.scss'],
})
export class CsbContractorBoxComponent implements OnInit {
  csbForm: FormGroup;
  selectedCountries: string[] = [];
  countries: string[] = [];
  @Output() continueClicked = new EventEmitter();
  @Output() cancelClicked = new EventEmitter();
  isWorkwithNmoChanged: boolean;
  isInitialState: boolean;
  selectedState = this._translate.instant('global.select');

  constructor(
    private formBuilder: FormBuilder,
    private _translate: TranslateService,
  ) {
    const countriesJson = this._translate.instant(
      'onboarding.addressInfo.stateList',
    ) as string[];
    this.countries = [...countriesJson].sort();
  }

  ngOnInit() {
    this.csbForm = this.formBuilder.group({
      workwithNmo: ['', Validators.required],
      workingState: ['', [validatorUtility.selectRequiredValidator]],
    });

    this.isInitialState = true;
  }

  onContinue() {
    this.continueClicked.emit();
  }

  cancelForm() {
    this.cancelClicked.emit();
  }

  workwithNmoChanged(hasWorkwithNmoChanged: boolean) {
    this.isWorkwithNmoChanged = hasWorkwithNmoChanged;
    this.isInitialState = false;

    if (!hasWorkwithNmoChanged) {
      this.csbForm.get('workingState')?.clearValidators();
      this.csbForm.get('workingState')?.patchValue('');

      this.csbForm.get('workingState')?.setValidators(Validators.required);
    }

    setTimeout(() => this.csbForm.updateValueAndValidity());
  }
}
